import React, { useState } from 'react';
import '../unAuth/Contact.css';
import emailjs from '@emailjs/browser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPills } from '@fortawesome/free-solid-svg-icons';
import { Navigate, useNavigate } from 'react-router-dom';

const Terms = () => {

  return (
    <div className="contact-background">
      <div className="contact-container">
        <h1 className="contact-title">Terms & Conditions </h1>
            <div className="terms-content">
          
<p>
Effective Date: 07-06-2025</p>
<p>These Terms & Conditions ("Terms") govern your access to and use of ClinicSync. By using our services, you agree to comply with and be bound by these Terms.</p>

<p>1. Use of the Service</p>
<p>
You agree to:

Use the platform only for lawful clinic-related activities.

Keep your login credentials secure.

Not misuse or attempt to reverse-engineer the software.
</p>
<p>2. Accounts and Access</p>
<p>
You must provide accurate information during signup.

We reserve the right to suspend accounts for suspicious or abusive behavior.
</p>
<p>3. Subscription & Trials</p>
<p>
New users may be offered a free trial (typically 7 days).

After the trial, access will be restricted unless a paid plan is selected.
</p>
<p>4. User Data</p>
<p>
You retain ownership of your clinic’s data.

We store and process it securely using third-party platforms like Firebase.
</p>
<p>5. Limitations of Liability</p>
<p>
We are not liable for:

Data loss caused by user error or third-party actions.

Downtime due to maintenance or technical issues.
</p>
<div>
<p>6. Termination </p>
</div>
<p>
We reserve the right to terminate accounts that violate these terms or misuse the system.
</p>
<p>7. Changes to These Terms</p>
<p>
We may update these Terms periodically. Continued use after updates means you accept the new terms.
</p>
<p>8. Contact</p>
<p>
For questions or support, reach out to:
📧 Email: info@osiqsolutions.com
📍 Address: OSIQ SOLUTIONS, Hyderabad, India

     </p>       
            </div>
      </div>
    </div>
  );
};

export default Terms;